import { lazy } from 'react';

/** Лениво загружает список бонусных счетов */
export const BonusAccountsPageAsync = lazy(() => import('./BonusAccounts/BonusAccountsPage'));
